export const ROLES = {
    ADMIN: "admin",
    SELLER: "seller",
    BUYER: "buyer",
    FREIGHT: "freight"
};

export const ROLE_LABELS = {
    admin: "Admin",
    seller: "Seller",
    buyer: "Buyer",
    freight: "Freight"
};